import { TextBadge } from '@carvana/ds-badge';
import { decorative } from '@carvana/ds-styles';

export default function NewBadge() {
  return (
    <TextBadge
      priority="custom"
      variant="strong"
      customBgColor={decorative['3Strong']}
      className="text-text-inverse"
    >
      Brand New
    </TextBadge>
  );
}
